import { NgTemplateOutlet } from '@angular/common';
import { Component, computed, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import type { OnyxColor } from '@onyx/angular';
import { OnyxDatePipe, OnyxTimePipe } from '@onyx/angular';
import { BUSINESS_HOURS_KEYS } from '../../../../constants/common/business-hours-keys';
import type { RoutePointValue } from '../../../../helpers/route.helper';
import { RouteHelper } from '../../../../helpers/route.helper';
import { RoutePointValueHelper } from '../../../../helpers/route-point-value.helper';
import type { RouteContext } from '../../../../interfaces/route/route-context';
import { BusinessHoursPipe } from '../../../../pipes/business-hours.pipe';

@Component({
  selector: 'app-route-point-time-windows',
  imports: [
    NgTemplateOutlet,
    TranslatePipe,
    OnyxTimePipe,
    OnyxDatePipe,
    BusinessHoursPipe,
  ],
  templateUrl: './route-point-time-windows.component.html',
  styleUrl: './route-point-time-windows.component.scss',
  host: {
    '[class.expanded]': `variant() === 'expanded'`,
  },
})
export class RoutePointTimeWindowsComponent {
  public readonly value = input.required<RoutePointValue>();
  public readonly context = input<RouteContext>('order');
  public readonly variant = input<'compact' | 'expanded'>('compact');
  public readonly color = input<OnyxColor | null>(null);

  protected timeWindows = computed(() =>
    RoutePointValueHelper.getTimeWindows(this.value()),
  );
  protected businessHours = computed(() =>
    RouteHelper.getBusinessHours(this.value()),
  );
  protected areBusinessHoursAlwaysOpen = computed(() =>
    RouteHelper.areBusinessHoursAlwaysOpen(this.value()),
  );
  protected businessHoursKeys = computed(() => {
    const businessHours = this.businessHours();
    if (!businessHours || this.areBusinessHoursAlwaysOpen()) return [];

    return BUSINESS_HOURS_KEYS.filter((key) => businessHours[key]);
  });
  protected statusColor = computed(() =>
    this.color() !== 'green' ? this.color() : null,
  );
}
